<template>
  <div>
     
    <h2 class="my-3">Guías reporte</h2>
    
    <div class="card">
      <div class="card-header">
        <nav class="navbar navbar-expand-lg" style="background-color: transparent;">
          <button
          class="navbar-toggler btn-color-principal mb-2 my-sm-0"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
          ><span class="navbar-toggler-icon"></span></button>
          <div class="collapse navbar-collapse justify-content-between" id="navbarNavDropdown">
            <form class="form-inline mb-2 my-sm-0" autocomplete="off" @submit.prevent="buscar">
              <select class="form-control my-1 my-sm-0 mr-sm-2" v-model="form.filtro" :required="true">
                <option v-for="i in listaFechas" :value="i.id" :key="i.id">{{ i.nombre }}</option>
              </select>
              <input
                class="form-control my-1 my-sm-0 mr-sm-2"
                type="date"
                title="Fecha Del"
                aria-label="Fecha Del"
                v-model.trim="form.inicio"
                :required="true"
              >
              <input
              class="form-control my-1 my-sm-0 mr-sm-2"
              type="date"
              title="Fecha Al"
              aria-label="Fecha Al"
              v-model.trim="form.fin"
              :required="true"
              >
              <select
                class="form-control my-1 my-sm-0 mr-sm-2"
                v-model="form.reintegro"
                :required="true"
              >
                <option v-for="i in listaReintegro" :value="i.id" :key="i.id">{{ i.nombre }}</option>
              </select>

              <button class="btn btn-lg btn-color-principal my-1 my-sm-0 mr-sm-2" type="submit" :disabled="inicio">
                <template v-if="inicio">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span class="sr-only">Loading...</span>
                </template>
                <template v-else>
                  <font-awesome-icon icon="search"/>
                </template>
              </button>
              <button class="btn btn-lg btn-color-principal my-1 my-sm-0 mr-sm-2" type="button" :disabled="btnCSV" @click="descargar">
                <template v-if="btnCSV">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span class="sr-only">Loading...</span>
                </template>
                <template v-else>
                  <i class="fa fa-download"></i> CSV
                </template>
              </button>
            </form>
            <div class="btn-group mb-2 my-sm-0" role="group" aria-label="First group" v-if="lista.length > 0">
              <button
                type="button"
                class="btn btn-success"
                title="Descargar Datos"
                @click="generarExcel({
                  idtabla: 'tblGuiaReporte',
                  extension: 'xls',
                  nombre: 'Guias'
                })"
              ><i class="fa fa-download"></i> Descargar</button>
            </div>
          </div>
        </nav>
      </div>
      <div class="table-responsive text-nowrap" v-if="lista.length > 0">
        <table class="table table-sm" id="tblGuiaReporte">
          <thead>
            <tr class="thead-light">
              <th scope="col">#</th>
              <th scope="col">Guía</th>
              <th scope="col">Órden</th>
              <th scope="col">Creación</th>
              <th scope="col">Confirmación</th>
              <th scope="col">Recolección</th>
              <th scope="col">Entrega</th>
              <th scope="col">Longitud</th>
              <th scope="col">Latitud</th>
              <th scope="col">Estado</th>
              <th scope="col">Destinatario</th>
              <th scope="col">Municipio</th>
              <th scope="col">Departamento</th>
              <th scope="col" class="text-center">Solicitud</th>
              <th scope="col" class="text-center">Servicio</th>
              <th scope="col" class="text-rigth">CCE Monto</th>
              <th scope="col" class="text-center">CCE Estatus</th>
              <th scope="col" class="text-center">Número de Boleta</th>
              <th scope="col" class="text-center">Fecha de Reintegro</th>
              <th scope="col" class="text-center">Indicador</th>
              <th scope="col">Sede</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idx) in lista" :key="i.id">
              <th scope="row">{{ (idx+1) }}</th>
              <td>{{ i.guia }}</td>
              <td>{{ i.orden }}</td>
              <td>{{ i.creacion }}</td>
              <td>{{ i.confirmacion }}</td>
              <td>{{ i.recoleccion }}</td>
              <td>{{ i.entrega }}</td>
              <td>{{ i.longitud }}</td>
              <td>{{ i.latitud }}</td>
              <td><span class="badge badge-primary">{{ i.estatus }}</span></td>
              <td>{{ i.destinatario }}</td>
              <td>{{ i.municipio }}</td>
              <td>{{ i.departamento }}</td>
              <td class="text-center">{{ i.solicitud }}</td>
              <td class="text-center">{{ i.servicio }}</td>
              <td class="text-rigth">{{ i.cod_monto }}</td>
              <td class="text-center">{{ i.ncod_estatus }}</td>
              <td class="text-center">{{ i.no_boleta }}</td>
              <td class="text-center">{{ i.fecha_boleta }}</td>
              <td class="text-center">{{ i.indicador }}</td>
              <td class="text-center">{{ i.sede }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import Notificacion from '../mixins/Notificacion.js'
  import linkDownload from '../mixins/Helper.js'

  export default {
    name: 'GuiaRep',
    mixins: [Notificacion],
    data: () => {
      return {
        error: null,
        inicio: false,
        form: {
          inicio: new Date().toJSON().slice(0,10),
          fin: new Date().toJSON().slice(0,10),
          filtro: 1,
          reintegro: 1
        },
        lista: [],
        actual: 1,
        listaFechas: [
          {id:1, nombre:'Creación'},
          {id:2, nombre:'Programación'},
          {id:3, nombre:'Confirmación'},
          {id:4, nombre:'Recolección'},
          {id:5, nombre:'Entrega'}
        ],
        listaReintegro: [
          {id:1, nombre:'Todas las guías'},
          {id:2, nombre:'Guías con reintegro'},
          {id:3, nombre:'Guías sin reintegro'}
        ],
        btnCSV: false
      }
    },
    methods: {
      errores (lista) {
        for (let index = 0; index < lista.length; index++) {
          const element = lista[index];
          this.showErrorMsg({
            title: `Error ${element.codigo}`,
            message: element.mensaje
          })
        }
      },
      buscar() {
        this.inicio = true
        this.error = null
        this.lista  = []
        axios
        .get(`${this.UrlBase}/reporte/guias`, {params:this.form})
        .then(res => {
          this.inicio = false
          this.lista  = res.data
        }).catch(e => {
          this.inicio = false
          
          if (e.response.data.errores !== undefined) {
            this.errores(e.response.data.errores)
          } else {
            alert('Guias '+e.message)
          }
        })
      },
      async descargar() {
        this.btnCSV = true

        try {
          const res = await axios({
            'Content-Type': 'text/csv',
            responseType: 'blob',
            url: `${this.UrlBase}/reporte/guias?format=csv`, 
            params: this.form
          })

          linkDownload(res.data, 'guias.csv')
        } catch (error) {
          if (error.response.data.type === 'application/json') {
            const txt = await error.response.data.text()
            const json = JSON.parse(txt)
            if (json.errores !== undefined) {
              this.errores(json.errores)
            } else {
              alert('Guias '+error.message)
            }
          } else {
            alert('Guias '+error.message)
          }
        }
        
        this.btnCSV = false
      },
      generarExcel(args) {
        
        let tab = document.getElementById(args.idtabla); // id of table

        if (tab === null) {
          alert('No hay datos que descargar')
          return false
        } else {
          let tab_text = '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN"><html><head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"/><title></title><meta name="generator" content="Gacela C807"/><style type="text/css">body,div,table,thead,tbody,tfoot,tr,th,td,p { font-family:"Liberation Sans"; font-size:x-small }</style></head><body><table>'; 
          let j = 0;

          for(j = 0 ; j < tab.rows.length ; j++) 
          {
            tab_text = tab_text+"<tr>"+tab.rows[j].innerHTML+"</tr>";
          }

          tab_text= tab_text+"</table></body></html>";
          tab_text= tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
          tab_text= tab_text.replace(/<img[^>]*>/gi,""); // remove if u want images in your table
          tab_text= tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // removes input params
          tab_text= tab_text.replace(/<button[^>]*>|<\/button>/gi, ""); // removes input params

          let a = document.createElement('a')
          let formato = 'application/vnd.oasis.opendocument.spreadsheet,'
          let extension = 'ods'
          
          if (args.extension) {
            extension = args.extension
            switch (args.extension) {
              case 'xls':
                formato = 'application/vnd.ms-excel,'
                break;
            
              default:
                extension = 'ods'
                break;
            }
          } 

          a.href = 'data:' + formato + encodeURIComponent(tab_text)
          a.download = args.nombre + '.' + extension
          a.click()
        }
      }
    },
    computed: {
      filtrada() {
        if (this.form.numero) {
          return this.lista.filter(o => {
            return o.guia.includes(this.form.numero)
          })
        } else {
          return this.lista
        }
      }
    }
  }
</script>
<style>
  .table {
    font-size: 0.90rem
  }
</style>